<template lang="pug">
div
  h2.title-200.text-gray(class="xl:mb-12") Vous ne trouvez pas l'offre qui vous correspond ?
  p(class="my-5 text-17") Renseignez votre adresse email pour être prévenu en avant-première des nouveaux biens correspondant à vos critères de recherche

  p.font-bold.mb-4 Vos critères
  div(class="w-4/5 mx-auto")
    div(v-html="alertTags")

  div(v-if="!success")
    form(class="max-w-80% mx-auto mt-10 text-left" @submit.prevent="handleSubmit")
      .form-group(v-if="Object.keys(errors).length")
        .alert.error_explanation
          form-error(:errors="errors")

      .grid.grid-cols-6.gap-2
        input.col-span-4.form-control(v-model="alert.email" type="email" required="required")
        button.col-span-2.btn.btn-primary.flex.justify-center.items-center(type="submit")
          .hidden.absolute(class="xl:inline-block xl:static")
            span Envoyer
          i.fal.fa-paper-plane.text-lg.ml-0(class="xl:ml-6")

      .mt-8(class="xl:flex")
        div
          label(class="checkbox-native inline-block font-sans relative pl-10 mr-12 text-xs font-light text-gray-800 cursor-pointer select-none")
            span En soumettant ce formulaire, j’accepte que les informations saisies dans ce formulaire soient utilisées, exploitées, traitées pour permettre de me recontacter.
            a(href="#")
              |  En savoir plus sur notre Politique d’utilisation des données.
            input(class="checkbox-native__input absolute opacity-0 cursor-pointer h-0 w-0" type="checkbox" name="rgpd_terms_accepted" value="true" v-model="alert.rgpd_terms_accepted")
            span(class="checkbox-native__checkmark absolute top-0 mt-4 transform -translate-y-1/2 left-0 w-6 h-6 border border-black rounded-sm")

  div(v-else)
    p.text-primary.font-bold.mt-12
      span  {{ success }}

</template>

<script>
import axios from 'axios'
import FormError from '@components/FormError'

export default {
  components: {
    FormError
  },

  data () {
    return {
      alert: {
        email: '',
        rgpd_terms_accepted: false
      },
      success: null,
      errors: []
    }
  },

  computed: {
    alertTags () {
      return this.$store.getters.getAlertTags
    }
  },

  methods: {
    handleSubmit () {
      axios.post('/alerts', {
        alert: {
          ...this.alert,
          params: this.$store.getters.getParams
        }
      })
        .then(response => {
          this.success = "L'alerte a été ajoutée avec succès"
          new FlashMessage("L'alerte a été ajoutée avec succès", "success")
        })
        .catch(({ response }) => {
          this.errors = response.data.errors.data.attributes.errors
          new FlashMessage("Une erreur s'est produite lors de la création de l'alerte", "danger")
        })
    }
  }
}
</script>
